import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import CustomerLayout from './components/CustomerLayout'
import Home from './pages/Home'
import CategoryView from './pages/CategoryView'
import ItemDetail from './pages/ItemDetail'
import Cart from './pages/Cart'
import Checkout from './pages/Checkout'
import OrderQRSuccess from './pages/OrderQRSuccess'
import OrderConfirmation from './pages/OrderConfirmation'
import MyOrders from './pages/MyOrders'
import Reservation from './pages/Reservation'
import ReservationSuccess from './pages/ReservationSuccess'

function App() {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route element={<CustomerLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/category/:categoryId" element={<CategoryView />} />
            <Route path="/item/:itemId" element={<ItemDetail />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/order-qr" element={<OrderQRSuccess />} />
            <Route path="/order-confirmation/:orderId" element={<OrderConfirmation />} />
            <Route path="/my-orders" element={<MyOrders />} />
            <Route path="/reservation" element={<Reservation />} />
            <Route path="/reservation-success" element={<ReservationSuccess />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  )
}

export default App

